import { render, staticRenderFns } from "./SeatbeltPage.vue?vue&type=template&id=2e1990c4&"
import script from "./SeatbeltPage.vue?vue&type=script&lang=js&"
export * from "./SeatbeltPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports